var map = {
	"./1": 202,
	"./1.jpg": 202,
	"./2": 203,
	"./2.jpg": 203,
	"./3": 204,
	"./3.jpg": 204,
	"./4": 205,
	"./4.jpg": 205,
	"./crime": 206,
	"./crime.png": 206,
	"./logo": 142,
	"./logo.png": 142,
	"./logo.svg": 480,
	"./logo_purple": 207,
	"./logo_purple.png": 207,
	"./picture_book": 208,
	"./picture_book.png": 208,
	"./shop_front": 209,
	"./shop_front.jpg": 209,
	"./subs_logo_bespoke": 210,
	"./subs_logo_bespoke.png": 210,
	"./subs_logo_reading_club": 211,
	"./subs_logo_reading_club.png": 211,
	"./torchlit_tales": 212,
	"./torchlit_tales.png": 212,
	"./torchlit_tales_name": 213,
	"./torchlit_tales_name.png": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;